import {useMutation, UseMutationResult} from "@tanstack/react-query";
import {api} from "@/features/api";

const usePostUserLeaveDelete: () => UseMutationResult<
  boolean,
  Error,
  unknown
> = () =>
  useMutation<boolean, Error, unknown>({
    mutationFn: async () => {
      const response = await api("TRENDARO_API_URL").post(`/users/me/leave`, {
        json: {immediateDelete: true},
      });

      if (response.status === 401)
        throw new Error("Neoprávněný přístup k Trendaro API.");

      if (!response.ok) {
        const data = await response.json();
        throw new Error(
          `HTTP ${response.status} při odesílání dat na Trendaro server. (${data?.error})`,
        );
      }

      return true;
    },
  });

export default usePostUserLeaveDelete;
